/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useStatuses = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.STATUSES,
    queryFn: async () => API.getInstance().getStatuses().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const statusesOptions = React.useMemo(
    () => data?.map((option) => ({ label: option, value: option })) || [],
    [data],
  );

  return {
    statusesLoading: isLoading,
    statusesOptions,
    data,
    error,
    fetchStatuses: refetch,
  };
};

export {
  useStatuses,
};
